import { useIntl } from "react-intl";
import { useWatch } from "react-hook-form";

import testIds from "constants/testIds";
import Textarea from "components/v2/Textarea/Textarea";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";

export default function MultistopInstructions() {
  const intl = useIntl();
  const stops = useWatch({ name: "schedule.stops" });

  if (!stops || stops.length <= 2) return null;

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.schedule.multistopInstructions",
          defaultMessage: "Multistop instructions",
        })}
      />
      <div className="rfv2-form-section__content">
        <Textarea
          name="schedule.multistop_instructions"
          label={intl.formatMessage({ id: "request-form.schedule.planning.instructions", defaultMessage: "Instructions" })}
          placeholder={intl.formatMessage({
            id: "request-form.schedule.instructionsPlaceholder",
            defaultMessage: "Type in your instructions",
          })}
          testId={testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_INSTRUCTIONS}
        />
      </div>
    </div>
  );
}
